import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FooterComponent} from './footer.component';

@NgModule({
    declarations: [FooterComponent],
    imports     : [BrowserModule],
    exports     : [FooterComponent],
})

export class FooterModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/footer/footer.module.ts